import React, { Component } from 'react';

import { ModalContainerProps } from './Modal.types';
import { mapDispatchToProps, mapStateToProps } from './ModalContainer';

export type ModalProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  ModalContainerProps;

export class Modal extends Component<ModalProps> {
  componentWillUnmount(): void {
    const { open, close } = this.props;

    if (open) {
      close();
    }
  }

  render() {
    const { open, children, ...props } = this.props;

    if (!open) {
      return null;
    }

    if (React.isValidElement(children)) {
      return React.cloneElement(children, { open, ...props } as any);
    }

    return null;
  }
}
